import axios from "axios";
import { formatfbInsightsData, formatTwitterInsightsData, getAccessToken, getReqParams, formatInstagramInsightsData } from "./utils";
import { getUrl } from "./urls";
import store from "../store";
import { getPostInfo } from "../components/MainContent/RawData/Post/postInfoUtils";
import {
    getParams,
    getFbParams,
    formatData,
    formatData_2,
    getParamsURLEncoded,
    formatTimeSeriesMentionsDaywise,
    formatGeneralTrends,
    formatGeneralTrendsWithTopics,
    getGeneralTrendsParams,
    formatLeaderboardAndHealthBooleanData,
    leaderboardAndHealthDataHelper,
    getFbUniqueParameter,
    getTwitterParams,
    getInstagramParams,
    getReachChartParams,
    getFBDate,
} from "./dashboardActionUtils";

import { toast } from "react-toastify";
import { resetReportFieldValue } from "./reportsAndAlertsActions";
import { formatTopicsSubtopics } from "../lib/formatFilter";
import moment from "moment-timezone";
// import { dispatch } from "d3";
import { ProductAttributes } from "../components/MainContent/Dashboard/ProductAttributeValues";
import { formatData as IgformatData } from "./insightsActionUtils";
export const CREATE_DASHBOARD = "CREATE_DASHBOARD";
export const CLONE_DASHBOARD = "CLONE_DASHBOARD";
export const SHARE_WITH_TEAM = "SHARE_WITH_TEAM";
export const SHARE_WITH_COMPANY = "SHARE_WITH_COMPANY";
export const SHARE_WITH_PUBLIC = "SHARE_WITH_PUBLIC";
export const STOP_SHARE_WITH_PUBLIC = "STOP_SHARE_WITH_PUBLIC";
export const FETCH_DASHBOARD_LIST = "FETCH_DASHBOARD_LIST";
export const FETCH__DELETED_DASHBOARD_LIST = "FETCH_DELETED_DASHBOARD_LIST";
export const FETCH_SYSTEM_WIDGETS_LIST = "FETCH_SYSTEM_WIDGETS_LIST";
export const FETCH_WIDGETS_LIST_DASHBOARD = "FETCH_WIDGETS_LIST_DASHBOARD";
export const UPDATE_CURRENT_DASHBOARD = "UPDATE_CURRENT_DASHBOARD";
export const UPDATE_TEMPORARY_PAGE_FILTERS = "UPDATE_TEMPORARY_PAGE_FILTERS";
export const UPDATE_RESEARCH_PAGE_FILTERS = "UPDATE_RESEARCH_PAGE_FILTERS";
export const REMOVE_CURRENT_DASHBOARD = "REMOVE_CURRENT_DASHBOARD";
export const UPDATE_CURRENT_DASHBOARD_FIELD = "UPDATE_CURRENT_DASHBOARD_FIELD";
export const RESET_CURRENT_DASHBOARD_FILTER = "RESET_CURRENT_DASHBOARD_FILTER";
export const FETCH_CHART_DATA = "FETCH_CHART_DATA";
export const FETCH_CHART_DATA_2 = "FETCH_CHART_DATA_2";
export const APPLY_FILTER_DASHBOARD = "APPLY_FILTER_DASHBOARD";
export const UPDATE_FILTER_REFINE_SORT_DASHBOARD = "UPDATE_FILTER_REFINE_SORT_DASHBOARD";
export const UPDATE_TAB_IN_VIEW = "UPDATE_TAB_IN_VIEW";
export const UPDATE_DASHBOARD_IN_VIEW = "UPDATE_DASHBOARD_IN_VIEW";
export const UPDATE_CONVERSATION_LAYOUT = "UPDATE_CONVERSATION_LAYOUT";
export const UPDATE_DASHBOARD = "UPDATE_DASHBOARD";
export const FETCH_CONVERSATION_DATA = "FETCH_CONVERSATION_DATA";
export const UPDATE_CUSTOM_QUERY_DASHBOARD = "UPDATE_CUSTOM_QUERY_DASHBOARD";
export const ADD_CUSTOM_QUERY = "ADD_CUSTOM_QUERY";
export const EDIT_CURRENT_DASHBOARD = "EDIT_CURRENT_DASHBOARD";
export const ADD_WIDGET_TO_DASHBOARD = "ADD_WIDGET_TO_DASHBOARD";
export const DELETE_WIDGET_FROM_DASHBOARD = "DELETE_WIDGET_FROM_DASHBOARD";
export const DELETE_DASHBOARD = "DELETE_DASHBOARD";
export const RESTORE_DASHBOARD = "RESTORE_DASHBOARD";
export const UPDATE_LIST_DASHBOARD_FIELD = "UPDATE_LIST_DASHBOARD_FIELD";
export const UPDATE_DASHBOARD_LAYOUT_CONFIG = "UPDATE_DASHBOARD_LAYOUT_CONFIG";
export const DASHBOARD_UPDATING_STATUS = "DASHBOARD_UPDATING_STATUS";
export const SAVE_DASHBOARD_WIDGET_LAYOUT_CONFIG = "SAVE_DASHBOARD_WIDGET_LAYOUT_CONFIG";
export const SENTIMENT_UPDATE = "SENTIMENT_UPDATE";
export const DASHBOARD_BULK_SENTIMENT_UPDATE = "DASHBOARD_BULK_SENTIMENT_UPDATE";

export const DASHBOARD_BULK_CONTENT_SAFETY_UPDATE = "DASHBOARD_BULK_CONTENT_SAFETY_UPDATE";
export const DASHBOARD_BULK_MARK_IRR_UPDATE = "DASHBOARD_BULK_MARK_IRR_UPDATE";
export const DASHBOARD_UPDATE_SENTIMENT_FOR_ALL = "DASHBOARD_UPDATE_SENTIMENT_FOR_ALL";
export const DASHBOARD_UPDATE_MARK_IRR_FOR_ALL = "DASHBOARD_UPDATE_MARK_IRR_FOR_ALL";
export const FETCH_BLOCK_SOURCE_MESSAGE = "FETCH_BLOCK_SOURCE_MESSAGE";
export const REMOVE_IRR_POST = "REMOVE_IRR_POST";
export const UPDATE_POSTS_AFTER_SENTIMENT_UPDATE = "UPDATE_POSTS_AFTER_SENTIMENT_UPDATE";
export const UPDATE_POSTS_AFTER_TAG_CLIENT = "UPDATE_POSTS_AFTER_TAG_CLIENT";
export const UPDATE_POSTS_AFTER_MARK_IRR = "UPDATE_POSTS_AFTER_MARK_IRR";
export const UPDATE_POSTS_AFTER_SENTIMENT_UPDATE_WIDGET = "UPDATE_POSTS_AFTER_SENTIMENT_UPDATE_WIDGET";
export const UPDATE_POSTS_AFTER_TAG_CLIENT_WIDGET = "UPDATE_POSTS_AFTER_TAG_CLIENT_WIDGET";
export const UPDATE_POSTS_AFTER_MARK_IRR_WIDGET = "UPDATE_POSTS_AFTER_MARK_IRR_WIDGET";
export const UPDATE_POSTS_AFTER_DELETE_FROM_COLLECTION = "UPDATE_POSTS_AFTER_DELETE_FROM_COLLECTION";
export const DASHBOARD_BULK_DELETE_FROM_COLLECTION = "DASHBOARD_BULK_DELETE_FROM_COLLECTION";
export const DASHBOARD_SHOW_BULK_EDIT_OPTIONS = "DASHBOARD_SHOW_BULK_EDIT_OPTIONS";
export const DASHBOARD_TOGGLE_SELECT_ALL = "DASHBOARD_TOGGLE_SELECT_ALL";
export const DASHBOARD_TOGGLE_SELECTED = "DASHBOARD_TOGGLE_SELECTED";
export const DASHBOARD_TOGGLE_TO_DESELECT = "DASHBOARD_TOGGLE_TO_DESELECT";
export const TOGGLE_FILTERS_COLUMN = "TOGGLE_FILTERS_COLUMN";
export const SET_STATIC_CHART_LOADER = "SET_STATIC_CHART_LOADER";
export const UPDATE_GRID_LAYOUT = "UPDATE_GRID_LAYOUT";
export const FETCH_FILTER_VALUE__FOR_IMAGE = "FETCH_FILTER_VALUE__FOR_IMAGE";
export const FETCH_IMAGE_LOGO_LIST = "FETCH_IMAGE_LOGO_LIST";
export const FETCH_IMAGE_SCENES_LIST = "FETCH_IMAGE_SCENES_LIST";
export const FETCH_IMAGE_OBJECTS_LIST = "FETCH_IMAGE_OBJECTS_LIST";
export const APPLY_IMAGE_FILTER = "APPLY_IMAGE_FILTER";
// export const SET_CUSTOM_VALUE = "SET_CUSTOM_VALUE";
export const UPDATE_DASHBOARD_CHART = "UPDATE_DASHBOARD_CHART";
export const CONFIG_IMAGE_LOGO_LIST = "CONFIG_IMAGE_LOGO_LIST";
export const FETCH_PUBLIC_DASHBOARD_INFO = "FETCH_PUBLIC_DASHBOARD_INFO";
export const IMAGE_ANALYTICS_MODAL_OPEN = "IMAGE_ANALYTICS_MODAL_OPEN";
export const SHOW_CHARTS_DRILLDOWN = "SHOW_CHARTS_DRILLDOWN";
export const UPDATE_CHART_INSIGHTS_FILTERS = "UPDATE_CHART_INSIGHTS_FILTERS";
export const SUPPORT_EMAIL = "SUPPORT_EMAIL";
export const VIEW_EXCLUDED_WORDS = "VIEW_EXCLUDED_WORDS";
export const MAXIMIZE_WIDGET = "MAXIMIZE_WIDGET";
// export const DELETE_COMPETITOR_ACCOUNT = "DELETE_COMPETITOR_ACCOUNT";
export const PUBLISHED_UPDATE_FILTER_REFINE_SORT_DASHBOARD = "PUBLISHED_UPDATE_FILTER_REFINE_SORT_DASHBOARD";
export const FETCH_ADVANCE_CHART_DATA = "FETCH_ADVANCE_CHART_DATA";
export const FETCH_ADVANCE_CHART_DATA_WRAPPER = "FETCH_ADVANCE_CHART_DATA_WRAPPER";
export const EXCLUDE_VIEW_COUNT_CHECKBOX = "EXCLUDE_VIEW_COUNT_CHECKBOX";

export const fetchDashboardList = () => {
    const req = axios
        .get(`${getUrl("dashboard_service")}/dashboards?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_DASHBOARD_LIST,
        payload: req,
    };
};

export const fetchDeletedDashboardList = () => {
    const req = axios
        .get(`${getUrl("dashboard_service")}/dashboards/deleted?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH__DELETED_DASHBOARD_LIST,
        payload: req,
    };
};

export const fetchSystemWidgetsList = () => {
    const req = axios
        .get(`${getUrl("dashboard_service")}/widgets/system?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            // console.log(res.data);
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_SYSTEM_WIDGETS_LIST,
        payload: req,
    };
};

export const fetchPublicDashboardInfo = (dashboard_id) => {
    const req = axios
        .get(`${getUrl("dashboard_service")}/dashboards/${dashboard_id}?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data.dashboard;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: UPDATE_CURRENT_DASHBOARD,
        payload: req,
    };
};

export const removeCurrentDashboard = () => {
    return {
        type: REMOVE_CURRENT_DASHBOARD,
    };
};

export const updateCurrentDashboard = (dashboard) => {
    return {
        type: UPDATE_CURRENT_DASHBOARD,
        payload: dashboard,
    };
};

export const updateResearchPageFilters = (search_list) => {
    return {
        type: UPDATE_RESEARCH_PAGE_FILTERS,
        payload: search_list,
    };
};

export const updateTemporaryPageFilters = (payload) => {
    return {
        type: UPDATE_TEMPORARY_PAGE_FILTERS,
        payload,
    };
};

export const updateCurrentDashboardField = (arg) => {
    return {
        type: UPDATE_CURRENT_DASHBOARD_FIELD,
        payload: arg,
    };
};

export const toggleFiltersColumn = (arg) => {
    return {
        type: TOGGLE_FILTERS_COLUMN,
        payload: arg,
    };
};

export const showChartsDrilldown = (bool, name) => {
    return {
        type: SHOW_CHARTS_DRILLDOWN,
        payload: [bool, name],
    };
};

export const imageAnalyticsFilterModal = (bool) => {
    return {
        type: IMAGE_ANALYTICS_MODAL_OPEN,
        payload: bool,
    };
};

export const resetFilterDashboard = () => {
    return {
        type: RESET_CURRENT_DASHBOARD_FILTER,
    };
};

export const fetchWidgetsListDashboard = (dashboard) => {
    const req = axios
        .get(`${getUrl("dashboard_service")}/dashboards/${dashboard}/widgets?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_WIDGETS_LIST_DASHBOARD,
        payload: req,
    };
};

export const fetchConversationData = (arg) => {
    const { filter } = arg;
    const data = getParams(filter);
    let req = axios
        .post(`${getUrl("raw_data")}`, data, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((res) => {
            return { ...res.data, offset: filter.offset, parmas: data };
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_CONVERSATION_DATA,
        payload: req,
    };
};

const getPreviousTotalData = async (data, filter, widget) => {
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    const startDate = moment(data.start_date);
    const endDate = moment(data.end_date);

    const duration = moment.duration(endDate.diff(startDate, "days")) + 1;

    let newStartDate;

    if (filter?.duration === "24HRS")
        newStartDate = startDate
            .tz(tz)
            .subtract(1440 - 1, "minutes")
            .format("YYYY-MM-DDTHH:mm:ss");
    else newStartDate = startDate.subtract(duration, "days").format();

    const url = `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}`;

    const newData = JSON.parse(JSON.stringify(data));
    newData.start_date = newStartDate;
    newData.end_date = data.start_date;

    return await axios
        .post(url, newData, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.log(err);
        });
};

export const getTotalValuesData = (arg) => {
    return (dispatch) => {
        const { widget, filter } = arg;
        const data = getParams(filter);

        const previousDataPromise = getPreviousTotalData(data, filter, widget);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url;
        if (filter.public_data === 1) url = `${getUrl("searchaggs")}`;
        else url = `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}`;

        const currentDataPromise = axios.post(url, data, {
            headers: {
                "Content-type": "application/json",
            },
        });

        const allPromise = Promise.all([previousDataPromise, currentDataPromise]);
        allPromise
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatData({
                        data: filter.public_data === 1 ? res[1].data : res[1].data.data,
                        chart_name: widget.chart_name,
                        params: data,
                        previousData: res[0].data.data,
                        widget: widget,
                    }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getWidgetData = (arg) => {
    return (dispatch) => {
        const { widget, filter, comparisionDataType } = arg;

        // if (arg.logos && arg.image_analytics_types) {
        if (arg.image_analytics_types) filter.image_analytics_types = arg.image_analytics_types;
        if (arg.logos) filter.logos = arg.logos;
        if (arg.product_attribute_categories) {
            if (arg.product_attribute_categories[0] === "selectAll")
                filter.product_attribute_categories = Object.keys(ProductAttributes.data).map((val) => ProductAttributes.data[val].categoryName);
            else filter.product_attribute_categories = arg.product_attribute_categories;
        }
        // }

        const data = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });
        let url;
        if (filter.public_data === 1) url = `${getUrl("searchaggs")}`;
        else url = `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}`;

        axios
            .post(url, data, {
                headers: {
                    "Content-type": "application/json",
                },
            })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({
                        data: filter.public_data === 1 ? res.data : res.data.data,
                        chart_name: widget.chart_name,
                        params: data,
                        comparisionData: comparisionDataType,
                    }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getWidgetData2 = (arg) => {
    return (dispatch) => {
        const { widget, filter } = arg;

        let data = getParams(filter);
        if (widget.chart_name === "mentionsMap") {
            data.aggs = "country_region_sentiments_breakup,country_sub_region_sentiments_breakup";
            data.lat_long_exact = "yes";
        }
        dispatch({ type: "FETCH_CHART_DATA_2_PENDING", widgetId: widget.id });
        axios
            .post(`${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}`, data, {
                headers: {
                    "Content-type": "application/json",
                },
            })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_2_FULFILLED",
                    widgetId: widget.id,
                    payload: formatData_2({ data: res.data.data, chart_name: widget.chart_name, params: data }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_2_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export let getFbInsightsData = (arg) => {
    return (dispatch) => {
        const { widget, filter, selectedFbPage, isUnique, activeIndex, order, orderBy, isAverage } = arg;

        if (!selectedFbPage?.value) return;

        const data = getFbParams({ filter, selectedFbPage, widget, activeIndex, isUnique });

        if (widget.chart_name === "fbRecentPosts") {
            dispatch(getFbRecentPostsData(data, widget, order, orderBy, selectedFbPage));
            return;
        }

        if (widget.chart_name === "fbPageEngagement") {
            dispatch(getFbPostEngagements(arg));
            return;
        }

        if (widget.chart_name === "fbTotalPostComments") {
            dispatch(getFbPostComments(arg));
            return;
        }

        if (widget.chart_name === "fbTotalPostShares") {
            dispatch(getFbPostShares(arg));
            return;
        }

        if (widget.chart_name === "fbTotalPostLikes") {
            dispatch(getFbPostLikes(arg));
            return;
        }

        if (widget.chart_name === "fbPostsOvertime") {
            dispatch(getFbPostOvertime(arg));
            return;
        }

        if (widget.chart_name === "fbPostTypeDistribution") {
            dispatch(getFbPostTypeDistribution(data, widget));
            return;
        }

        if (widget.chart_name === "fbTotalFollowersCount") {
            dispatch(fetchFbPageFollowers(selectedFbPage, widget));
            return;
        }

        if (["fbTotalReachCount", "fbTotalEngagementCount"].includes(widget.chart_name)) {
            dispatch(getFbTotalValuesData(arg));
            return;
        }

        if (isAverage) {
            dispatch(getAvgFbInsightsData(arg));
            return;
        }

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("socialInsights")}`;
        axios
            .post(url, data, {
                headers: {
                    "Content-type": "application/json",
                },
            })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    // payload: formatData({ data: filter.public_data === 1 ? res.data : res.data.data, chart_name: widget.chart_name, params: data }),
                    payload: formatfbInsightsData(
                        res.data,
                        data.start_date,
                        data.end_date,
                        activeIndex === 0 ? getFbUniqueParameter(widget.chart_name, isUnique) : null,
                        data.agreegate_interval,
                    ),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export let getAvgFbInsightsData = (arg) => {
    return (dispatch) => {
        const { widget, filter, selectedFbPage, isUnique, activeIndex } = arg;

        if (!selectedFbPage?.value) return;

        const data = getFbParams({ filter, selectedFbPage, widget, activeIndex, isUnique });

        const aggs_val = data["agreegate_interval"];

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else if (aggs_val === "daily") interval = "day";
            else interval = aggs_val;
        }

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("socialInsights")}`;
        axios
            .post(url, data, {
                headers: {
                    "Content-type": "application/json",
                },
            })
            .then((res) => {
                const countData = widget.chart_name === "fbTotalPostLikes" ? res.data : res.data?.total;

                let params = new URLSearchParams();

                params.append("start_date", data.start_date);
                params.append("end_date", data.end_date);
                params.append("data", "0");
                params.append("orderBy", "post.published_date");
                params.append("order", "desc");
                params.append("offset", "1");
                params.append("recordsPerPage", "50");
                params.append("post_type", "0");
                params.append("aggs-interval", interval);
                params.append("aggs", "conversation-over-time");
                params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
                params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

                axios
                    .post(getUrl("searchaggs"), params, {
                        cache: false,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    })
                    .then((response) => {
                        dispatch({
                            type: "FETCH_CHART_DATA_FULFILLED",
                            widgetId: widget.id,

                            payload: formatfbInsightsData(
                                { postData: response.data?.aggregations?.conversation_over_time?.buckets, countData },
                                data.start_date,
                                data.end_date,
                                widget.chart_name === "fbTotalPostLikes" ? "totalAveragePostLikes" : "totalAverageEngagement",
                                data.agreegate_interval,
                            ),
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                        dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                        return err;
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const getFbPreviousTotalData = async (data, filter, widget) => {
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    const startDate = moment(data.start_date);
    const endDate = moment(data.end_date);

    const duration = moment.duration(endDate.diff(startDate, "days")) + 1;

    let newStartDate;

    if (filter?.duration === "24HRS")
        newStartDate = startDate
            .tz(tz)
            .subtract(1440 - 1, "minutes")
            .format("YYYY-MM-DDTHH:mm:ss");
    else newStartDate = startDate.subtract(duration, "days").format();

    let url = `${getUrl("socialInsights")}`;

    const newData = JSON.parse(JSON.stringify(data));
    newData.start_date = newStartDate;
    newData.end_date = data.start_date;

    return await axios
        .post(url, newData, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.log(err);
        });
};

export const getFbTotalValuesData = (arg) => {
    return (dispatch) => {
        const { widget, filter, selectedFbPage } = arg;

        const data = getFbParams({ filter, selectedFbPage, widget });

        const previousDataPromise = getFbPreviousTotalData(data, filter, widget);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("socialInsights")}`;

        const currentDataPromise = axios.post(url, data, {
            headers: {
                "Content-type": "application/json",
            },
        });

        const allPromise = Promise.all([previousDataPromise, currentDataPromise]);
        allPromise
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatfbInsightsData(res, data.start_date, data.end_date, filter.aggs, widget.chart_name),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const fetchFbPageFollowers = (selectedFbPage, widget) => {
    // console.log(selectedFbPage);
    if (selectedFbPage.status !== "Inactive") {
        return (dispatch) => {
            axios({
                method: "get",
                url: `https://graph.facebook.com/v12.0/${selectedFbPage.value}?fields=followers_count&access_token=${selectedFbPage.access_token}`,
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((res) => {
                    dispatch({
                        type: "FETCH_CHART_DATA_FULFILLED",
                        widgetId: widget.id,
                        payload: res.data,
                    });
                })
                .catch((err) => {
                    console.log(err);
                    dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                    return err;
                });
        };
    } else {
        return (dispatch) => {
            dispatch({
                type: "FETCH_CHART_DATA_FULFILLED",
                widgetId: widget.id,
                payload: { followers_count: 0 },
            });
        };
    }
};

export let getFbRecentPostsData = (data, widget, postOrder, postOrderBy, selectedFbPage) => {
    return (dispatch) => {
        let params = new URLSearchParams();

        let order, orderBy;
        order = postOrder;
        orderBy = postOrderBy;

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "1");
        params.append("orderBy", orderBy);
        params.append("order", order);
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
        // params.append("custom_query", `post.page_id:${data.page_id}`);
        params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("searchaggs")}`;
        axios
            .post(url, params, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatfbInsightsData(response.data?.hits?.hits, data.start_date, data.end_date, "fbRecentPosts", null),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export let getFbPostTypeDistribution = (data, widget) => {
    return (dispatch) => {
        let params = new URLSearchParams();

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "0");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "20");
        params.append("custom_query", `post.page_id:${data.page_id}`);
        params.append("aggs", "post-media-breakup");

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("searchaggs")}`;
        axios
            .post(url, params, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatfbInsightsData(
                        response.data?.aggregations?.post_media_breakup?.buckets,
                        data.start_date,
                        data.end_date,
                        "fbPostTypeDistribution",
                        null,
                    ),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getInstagramInsightsData = (arg) => {
    const { widget, filter, selectedInstagramPage, activeTab, showUniqueLines, order, orderBy, isAverage, recentPostsType } = arg;

    let params = getInstagramParams(widget, filter, selectedInstagramPage, activeTab, showUniqueLines);
    let chartName = params["chart_name"];
    delete params["chart_name"];

    return function (dispatch) {
        if (widget.chart_name === "IgRecentPosts") {
            dispatch(getIgRecentPostsData(params, widget, order, orderBy, selectedInstagramPage, recentPostsType));
            return;
        }
        if (widget.chart_name === "IgRecentStories") {
            dispatch(getIgRecentStoryData(params, widget, order, orderBy, selectedInstagramPage));
            return;
        }
        if (widget.chart_name === "IgStoriesMediaBreakup") {
            dispatch(getIgStoryMediaBreakdown(arg));
            return;
        }

        if (widget.chart_name === "IgPageEngagement") {
            dispatch(getIgPostEngagements(arg));
            return;
        }
        if (widget.chart_name === "IgtotalReach") {
            dispatch(getIgTotalReach(arg));
            return;
        }

        if (widget.chart_name === "IgPostsLikes") {
            dispatch(getIgPostLikes(arg));
            return;
        }

        if (widget.chart_name === "IgPostsComments") {
            dispatch(getIgPostComments(arg));
            return;
        }
        if (widget.chart_name === "IgPostImpressions") {
            dispatch(getIgPostImpressions(arg));
            return;
        }
        if (widget.chart_name === "IgPostReach") {
            dispatch(getIgPostReach(arg));
            return;
        }

        if (widget.chart_name === "IgStoriesEngagement") {
            if (activeTab === 0) {
                dispatch(getIgStoryViewsAndExits(arg));
                return;
            } else if (activeTab === 1) {
                dispatch(getIgStoryReplies(arg));
                return;
            } else if (activeTab === 2) {
                dispatch(getIgStoryTaps(arg));
                return;
            } else if (activeTab === 3) {
                dispatch(getIgStoryReach(arg));
                return;
            }
        }

        if (widget.chart_name === "IgPostsOvertime") {
            dispatch(getIgPostOvertime(arg));
            return;
        }
        if (widget.chart_name === "IgStoriesOvertime") {
            dispatch(getIgStoryOvertime(arg));
            return;
        }

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        axios({
            method: "post",
            url: getUrl("ig_insights_metrics"),
            data: params,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatInstagramInsightsData(res.data, params.start_date, params.end_date, chartName),
                });
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getAvgInstagramInsightsData = (arg, chartName) => {
    const { widget, filter, selectedInstagramPage, activeTab, showUniqueLines, order, orderBy, isAverage } = arg;

    let chartParams = getInstagramParams(widget, filter, selectedInstagramPage, activeTab, showUniqueLines);

    const aggs_val = chartParams["agreegate_interval"];

    let interval;
    if (aggs_val) {
        if (aggs_val === "yearly") interval = "year";
        else if (aggs_val === "monthly") interval = "month";
        else if (aggs_val === "weekly") interval = "week";
        else if (aggs_val === "daily") interval = "day";
        else interval = aggs_val;
    }

    return function (dispatch) {
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        axios({
            method: "post",
            url: getUrl("ig_insights_metrics"),
            data: chartParams,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                const countData = res.data.data;

                let params = new URLSearchParams();

                params.append("start_date", chartParams.start_date);
                params.append("end_date", chartParams.end_date);
                params.append("data", "0");
                params.append("orderBy", "post.published_date");
                params.append("order", "desc");
                params.append("offset", "1");
                params.append("recordsPerPage", "50");
                params.append("post_type", "0");
                params.append("aggs-interval", interval);
                params.append("aggs", "conversation-over-time");
                params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
                params.append("custom_query", `handlers.value:"${selectedInstagramPage?.handler}"`);

                axios
                    .post(getUrl("searchaggs"), params, {
                        cache: false,
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        },
                    })
                    .then((response) => {
                        dispatch({
                            type: "FETCH_CHART_DATA_FULFILLED",
                            widgetId: widget.id,
                            payload: formatInstagramInsightsData(
                                { postData: response.data?.aggregations?.conversation_over_time?.buckets, countData: countData.total },
                                params.start_date,
                                params.end_date,
                                chartName,
                                isAverage,
                            ),
                        });
                    })
                    .catch((err) => {
                        toast.error(err.response?.data.message);
                        dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                        return err;
                    });
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
            });
    };
};

export let getIgRecentPostsData = (data, widget, postOrder, postOrderBy, selectedIgPage, recentPostsType) => {
    return (dispatch) => {
        let params = new URLSearchParams();

        let order, orderBy;
        order = postOrder;
        orderBy = postOrderBy;

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "1");
        params.append("orderBy", orderBy);
        params.append("order", order);
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        if (recentPostsType && recentPostsType !== "all") params.append("post_media_type", recentPostsType);
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        // params.append("custom_query", `post.page_id:${data.account_id}`);
        params.append("custom_query", `handlers.value:"${selectedIgPage?.handler}"`);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("searchaggs")}`;
        axios
            .post(url, params, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatInstagramInsightsData(response.data?.hits?.hits, data.start_date, data.end_date, "IgRecentPosts"),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export let getIgRecentStoryData = (data, widget, postOrder, postOrderBy, selectedIgPage) => {
    return (dispatch) => {
        let params = new URLSearchParams();

        let order, orderBy;
        order = postOrder;
        orderBy = postOrderBy;

        params.append("start_date", data.start_date);
        params.append("end_date", data.end_date);
        params.append("data", "1");
        params.append("orderBy", orderBy);
        params.append("order", order);
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("post_type", "0");
        params.append("post_subtype", "story");
        params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        params.append("custom_query", `handlers.value:"${selectedIgPage?.handler}"`);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("searchaggs")}`;
        axios
            .post(url, params, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatInstagramInsightsData(response.data?.hits?.hits, data.start_date, data.end_date, "IgRecentStories"),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getInstagramFollowersCount = (arg) => {
    let params = {};
    const { widget, filter, selectedInstagramPage, activeTab } = arg;
    params["page_id"] = selectedInstagramPage.value;
    params["access_token"] = selectedInstagramPage.access_token;
    let chartName = widget["chart_name"];
    return function (dispatch) {
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let res = axios({
            method: "get",
            url: `https://graph.facebook.com/v12.0/${params.page_id}?fields=followers_count&access_token=${params.access_token}`,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: res.data,
                });
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
                // dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: {},
                });
                return err;
            });
    };
};

export const getTwitterInsightsData = (arg) => {
    const { widget, filter, selectedTwitterPage, getTotalPosts } = arg;

    const data = getTwitterParams({ filter, selectedTwitterPage });

    if (filter.aggs === "basic_metric") {
        return (dispatch) => dispatch(getTwitterTotalValuesData(data, widget));
    }

    return (dispatch) => {
        let metrics = data.metrics.split("-")[0];
        if (getTotalPosts) metrics = metrics + ",recent_posts_count";

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("twitterInsights")}?page_id=${data.page_id}&end_date=${data.end_date}&start_date=${
            data.start_date
        }&metrics=${metrics}&agreegate_interval=${data.agreegate_interval}`;
        axios
            .get(url, {
                headers: {
                    "Content-type": "application/json",
                    "access-token": getAccessToken(),
                },
            })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatTwitterInsightsData(res.data, data.start_date, data.end_date, data.metrics),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getAvgTwitterInsightsData = (arg) => {
    const { widget, filter, selectedTwitterPage } = arg;

    const data = getTwitterParams({ filter, selectedTwitterPage });

    return (dispatch) => {
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("twitterInsights")}?page_id=${data.page_id}&end_date=${data.end_date}&start_date=${data.start_date}&metrics=${
            data.metrics.split("-")[0]
        }&agreegate_interval=${data.agreegate_interval}`;
        axios
            .get(url, {
                headers: {
                    "Content-type": "application/json",
                    "access-token": getAccessToken(),
                },
            })
            .then((res) => {
                const countData = res.data;

                let url = `${getUrl("twitterInsights")}?page_id=${selectedTwitterPage?.value}&end_date=${data.end_date}&start_date=${
                    data.start_date
                }&metrics=tweet_overtime&agreegate_interval=${data.agreegate_interval}`;
                axios
                    .get(url, {
                        headers: {
                            "Content-type": "application/json",
                            "access-token": getAccessToken(),
                        },
                    })
                    .then((response) => {
                        dispatch({
                            type: "FETCH_CHART_DATA_FULFILLED",
                            widgetId: widget.id,
                            payload: formatTwitterInsightsData(
                                { postData: response.data, countData },
                                filter.start_date,
                                filter.end_date,
                                "averageLikesOverTime",
                            ),
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                        dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                        return err;
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const getTwitterPreviousTotalData = async (data) => {
    const startDate = moment(new Date(data.start_date).toLocaleDateString());
    const endDate = moment(new Date(data.end_date).toLocaleDateString());

    const duration = moment.duration({ days: endDate.diff(startDate, "days") }) + 1;

    const newStartDate = moment(startDate.subtract(duration)._d).format();

    const newData = JSON.parse(JSON.stringify(data));
    newData.start_date = newStartDate;
    newData.end_date = data.start_date;

    let url = `${getUrl("twitterInsights")}?page_id=${data.page_id}&end_date=${newData.end_date}&start_date=${newData.start_date}&metrics=${
        data.metrics.split("-")[0]
    }`;

    return await axios
        .get(url, {
            headers: {
                "Content-type": "application/json",
                "access-token": getAccessToken(),
            },
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.log(err);
        });
};

export const getTwitterTotalValuesData = (data, widget) => {
    return (dispatch) => {
        const previousDataPromise = getTwitterPreviousTotalData(data);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        let url = `${getUrl("twitterInsights")}?page_id=${data.page_id}&end_date=${data.end_date}&start_date=${data.start_date}&metrics=${
            data.metrics.split("-")[0]
        }`;

        const currentDataPromise = axios.get(url, {
            headers: {
                "Content-type": "application/json",
                "access-token": getAccessToken(),
            },
        });

        const allPromise = Promise.all([previousDataPromise, currentDataPromise]);
        allPromise
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatTwitterInsightsData(res, data.start_date, data.end_date, data.metrics),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const wordCloudExclusion = (data) => {
    let req = axios
        .post(`${getUrl("wordcloud_exclusion")}`, data, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((res) => {
            toast.success("Word excluded successfully!");
            return res;
        })
        .catch((err) => {
            toast.success("Word exclusion failed!");
            console.log(err);
            return err;
        });

    return {
        type: "WORDCLOUD_EXCLUSION",
        payload: req,
    };
};

export const getVOCSubtpcsCnt = (arg) => {
    return (dispatch) => {
        const { widget } = arg;
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        fetchVOCSubtpcsCnt(arg)
            .then(({ res, params }) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getOverallShareOfVoice = (arg) => {
    return (dispatch) => {
        const { filter, widget, comparisionDataType } = arg;
        // if (filter.topics_data.length === 0) filter.topics_data = formatTopicsSubtopics({ filter_data: { topics: [], subtopics: [] } }, false, true);
        let params = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });

        return axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=overallShareOfVoice`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};
export const uniqueUsersOverTimeByTopics = (arg) => {
    return (dispatch) => {
        const { filter, widget, comparisionDataType } = arg;
        let params = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });

        return axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=uniqueUserByTopic`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const uniqueUsersOverTimeBySubTopics = (arg) => {
    return (dispatch) => {
        const { filter, widget, comparisionDataType } = arg;
        let params = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });

        return axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=uniqueUserBySubtopic`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getShareOfVoiceBySubtopicsData = (arg) => {
    return (dispatch) => {
        const { filter, widget, comparisionDataType } = arg;
        // if (filter.topics_data.length === 0) filter.topics_data = formatTopicsSubtopics({ filter_data: { topics: [], subtopics: [] } }, false, true);
        let params = getParams(filter);
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });
        axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=shareofVoiceBySubtopic`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getTopicWiseStackedPlatformBreakDown = (arg) => {
    return (dispatch) => {
        const { filter, widget, comparisionDataType } = arg;
        let params = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });

        return axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=platformMentionsByTopic`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};
export const getSubTopicWiseStackedPlatformBreakDown = (arg) => {
    return (dispatch) => {
        const { filter, widget, comparisionDataType } = arg;
        let params = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });

        return axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=dataBySubTopic`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getEngagementOverTimeByTopics = (arg) => {
    return (dispatch) => {
        const { filter, widget, comparisionDataType } = arg;
        let params = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });

        return axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=enegagementoverTimeByTopic`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getEngagementOverTimeBySubtopic = (arg) => {
    return (dispatch) => {
        const { filter, widget, comparisionDataType } = arg;
        let params = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });

        return axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=dataBySubTopic`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getShareOfVoiceByNewsData = (arg) => {
    return (dispatch) => {
        const { filter, widget } = arg;
        // if (filter.topics_data.length === 0) filter.topics_data = formatTopicsSubtopics({ filter_data: { topics: [], subtopics: [] } }, false, true);
        let params = getParams(filter);
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        axios({
            method: "post",
            url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=shareofVoiceByNewsSources`,

            headers: {
                "Content-Type": "application/json",
            },
            data: params,
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getTopInfluencersData = (arg) => {
    return (dispatch) => {
        const { widget, filter } = arg;
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        fetchTopInfluencers(arg)
            .then((res) => {
                // console.log(res.data);
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: filter.public_data === 1 ? res.data : res.data.data,
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getTopicWiseSentimentBreakupData = (arg) => {
    return (dispatch) => {
        const { widget } = arg;
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        fetchTopicWiseSentimentBreakup(arg)
            .then(({ res, params }) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};
export const getSubTopicWiseSentimentBreakupData = (arg) => {
    return (dispatch) => {
        const { widget } = arg;
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        fetchSubTopicWiseSentimentBreakup(arg)
            .then(({ res, params }) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export const getGeneralTrendsData = (arg) => {
    return (dispatch) => {
        //const { widget } = arg;
        const { widget, filter, comparisionDataType } = arg;
        const data = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });
        fetchGeneralTrends(arg)
            .then(({ res, params }) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({ data: res.data.data, chart_name: widget.chart_name, params: data }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};
const fetchReachPhase = (params) => {
    return axios
        .post(`${getUrl("ig_insights_metrics")}`, params, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((res) => res);
};
export const getReachPercentageData = (arg) => {
    const { widget, filter, selectedInstagramPage } = arg;
    let { param1, param2 } = getReachChartParams(arg);
    let req1 = fetchReachPhase(param1)
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            return err;
        });
    let req2 = fetchReachPhase(param2)
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            return err;
        });
    let req = Promise.all([req1, req2]);
    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });
        req.then((res) => {
            dispatch({
                type: "FETCH_CHART_DATA_FULFILLED",
                widgetId: widget.id,
                payload: { [arg.first_key]: res[0], [arg.second_key]: res[1] },
            });
        }).catch((err) => {
            console.log(err);
            dispatch({
                type: "FETCH_CHART_DATA_REJECTED",
                widgetId: widget.id,
            });
        });
    };
};

const getFbPostEngagements = (args) => {
    const { widget, filter, selectedFbPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "comments_datewise_breakdown,shares_datewise_breakdown,reactions_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = formatfbInsightsData(response.data, start_date, end_date, "totalAverageEngagement", aggs_val);

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formattedData,
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getFbPostShares = (args) => {
    const { widget, filter, selectedFbPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "shares_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = formatfbInsightsData(response.data, start_date, end_date, "totalPostShares", aggs_val);

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formattedData,
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getFbPostComments = (args) => {
    const { widget, filter, selectedFbPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "comments_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = formatfbInsightsData(response.data, start_date, end_date, "totalPostComments", aggs_val);

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formattedData,
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getFbPostLikes = (args) => {
    const { widget, filter, selectedFbPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "reactions_datewise_breakdown");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = formatfbInsightsData(response.data, start_date, end_date, "totalPostLikes", aggs_val);

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formattedData,
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgPostEngagements = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown,view_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "engagement_over_time" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { engagement_over_time: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgPostLikes = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "likes_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_post_likes" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_post_likes: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgPostComments = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "comments_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_post_comments" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_post_comments: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgPostImpressions = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "impressions_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_post_impressions" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_post_impressions: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgReachOverTimeData = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "view_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};

const getIgPostReach = (args) => {
    const { widget } = args;

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        getIgReachOverTimeData(args)
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_post_reach" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_post_reach: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgTotalReach = (args) => {
    const { widget } = args;

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        let reach1 = getIgReachOverTimeData(args).then((res) => ({ name: "reach1", data: res.data }));
        let args2 = JSON.parse(JSON.stringify(args));
        // console.log(args);

        let start_date, end_date;
        let params = getParams(args2.filter);

        start_date = params.start_date;
        end_date = params.end_date;

        let durationGap = moment(end_date).diff(moment(start_date), "days", true);
        args2.filter["start_date"] = moment(start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DDTHH:mm:ss");
        args2.filter["end_date"] = moment(start_date).subtract(1, "day").format("YYYY-MM-DDTHH:mm:ss");
        args2.filter.duration = "custom";
        args2.filter.rollingDate = false;

        // console.log(args2);
        let reach2 = getIgReachOverTimeData(args2).then((res) => ({ name: "reach2", data: res.data }));

        Promise.all([reach1, reach2])
            .then((response) => {
                let formattedData = IgformatData({ response: response, durationGap, chart_name: "total_reach" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { total_reach: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgStoryViewsAndExits = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("post_subtype", "story");
    params.append("aggs-interval", interval);
    params.append("aggs", "view_datewise_breakdown,exits_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_story" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_story: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgStoryReplies = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("post_subtype", "story");
    params.append("aggs-interval", interval);
    params.append("aggs", "comments_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_story_replies" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_story_replies: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgStoryTaps = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("post_subtype", "story");
    params.append("aggs-interval", interval);
    params.append("aggs", "taps_forwards_datewise_breakdown,taps_backwards_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_story_by_taps" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_story_by_taps: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgStoryReach = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("post_subtype", "story");
    params.append("aggs-interval", interval);
    params.append("aggs", "view_datewise_breakdown");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_story_by_reach" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_story_by_reach: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgStoryMediaBreakdown = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("post_subtype", "story");
    params.append("aggs", "post-media-breakup");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_story_media_breakup" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_story_media_breakup: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getFbPostOvertime = (args) => {
    const { widget, filter, selectedFbPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "conversation-over-time");
    params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedFbPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = formatfbInsightsData(
                    response.data?.aggregations?.conversation_over_time?.buckets,
                    start_date,
                    end_date,
                    "fbPostOvertime",
                    aggs_val,
                );

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: formattedData,
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgPostOvertime = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("aggs-interval", interval);
    params.append("aggs", "conversation-over-time");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_posts_overtime" });

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_posts_overtime: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

const getIgStoryOvertime = (args) => {
    const { widget, filter, selectedInstagramPage, aggs_val } = args;
    let interval = aggs_val;

    let params = new URLSearchParams();

    let { start_date, end_date } = getFBDate(filter);

    params.append("start_date", start_date);
    params.append("end_date", end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("post_subtype", "story");
    params.append("aggs-interval", interval);
    params.append("aggs", "conversation-over-time");
    params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers.value:"${selectedInstagramPage.handler}"`);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let formattedData = IgformatData({ response: response.data, chart_name: "insta_story_overtime" });
                // console.log(formattedData);
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: { insta_story_overtime: formattedData },
                });
                return formattedData;
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_CHART_DATA_REJECTED",
                    widgetId: widget.id,
                });
            });
    };
};

export const getGeneralTrendsWithTopicsData = (arg) => {
    // const { widget } = arg;
    const { widget, filter, comparisionDataType } = arg;
    const data = getParams(filter);

    let req1 = fetchVOCSubtpcsCntDaywise(arg)
        .then((res) => res.data.data)
        .then((data) => formatTimeSeriesMentionsDaywise(data.dataSet))
        .catch((err) => {
            console.log(err);
            throw new Error();
        });

    let req2 = fetchGeneralTrends(arg)
        .then((res) => res.res.data.data)
        .then((data) => formatGeneralTrendsWithTopics(data));

    let req = Promise.all([req1, req2]);

    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
            comparisionData: comparisionDataType,
        });
        req.then((res) => {
            dispatch({
                type: "FETCH_CHART_DATA_FULFILLED",
                widgetId: widget.id,
                comparisionData: comparisionDataType,
                payload: formatData({ data: res, chart_name: widget.chart_name, params: data }),
            });
        }).catch((err) => {
            console.log(err);
            dispatch({
                type: "FETCH_CHART_DATA_REJECTED",
                widgetId: widget.id,
            });
        });
    };
};

const getSubtopicsBoolArray = (topic_data) => {
    let subtopics = [];
    topic_data?.forEach((t) => {
        t.subtopicNames.forEach((s) => subtopics.push({ ...s, topic_name: t.name }));
    });
    subtopics.sort((a, b) => {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        let comparison = 0;
        if (textA > textB) comparison = 1;
        else if (textA < textB) comparison = -1;

        return comparison;
    });
    return subtopics;
};

const getTopicsBoolArray = (topic_data) => {
    let subtopics = [];

    topic_data.forEach((elem) => {
        subtopics.push(elem.subtopicIds);
    });
    return subtopics;
};

export const getLeaderboardAndHealthData = (arg) => {
    const { widget, filter, extras } = arg;
    const data = getParams(filter);
    let groupByTopics = false;
    if (extras && extras.groupByTopics) {
        groupByTopics = true;
    }
    let xs = leaderboardAndHealthDataHelper(filter);
    let r = fetchLeaderboardAndHealthData({ widget, data, groupByTopics })
        .then((res) => {
            return res.data;
        })
        .then((res) => formatLeaderboardAndHealthBooleanData({ res: res.data, xs, groupByTopics, params: data }));
    return function (dispatch) {
        dispatch({
            type: "FETCH_CHART_DATA_PENDING",
            widgetId: widget.id,
        });
        r.then((formattedData) => {
            dispatch({
                type: "FETCH_CHART_DATA_FULFILLED",
                widgetId: widget.id,
                payload: { data: formattedData, chart_name: widget.chart_name, params: data },
            });
        }).catch((err) => {
            dispatch({
                type: "FETCH_CHART_DATA_REJECTED",
                widgetId: widget.id,
            });
        });
    };
};

export const fetchLeaderboardAndHealthData = (arg) => {
    const { widget, data, groupByTopics } = arg;
    const apiWrapperIdentifiers = groupByTopics ? "dataByTopic" : "dataBySubTopic";

    return axios.post(
        `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=${apiWrapperIdentifiers}`,
        data,
        {
            headers: {
                "Content-type": "application/json",
            },
        },
    );
};

const fetchGeneralTrends = (arg) => {
    const { filter, widget } = arg;

    let params = getGeneralTrendsParams(filter);

    return axios
        .post(`${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=countryWise`, params, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        })
        .then((res) => ({ res, params }));
};

const fetchVOCSubtpcsCnt = (arg) => {
    const { filter, widget } = arg;
    // if (filter.topics_data.length === 0) filter.topics_data = formatTopicsSubtopics({ filter_data: { topics: [], subtopics: [] } }, false, true);
    let params = getParams(filter);
    const data = getParamsURLEncoded(params);

    return axios({
        method: "post",
        url: `${getUrl("dashboard_service")}/widgets/${
            widget.id
        }/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=volumeOfConversationSubtopicCountWithOverall`,

        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => ({ res, params }));
};

const fetchVOCSubtpcsCntDaywise = (arg) => {
    const { filter, widget } = arg;
    const data = getParamsURLEncoded(getParams(filter));

    return axios({
        method: "post",
        url: `${getUrl("dashboard_service")}/widgets/${
            widget.id
        }/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=volumeOfConversationSubtopicCountDaywiseOverall`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    });
};

export const fetchTopicWiseSentimentBreakup = (arg) => {
    const { filter, widget } = arg;
    let params = getParams(filter);
    const data = getParamsURLEncoded(params);

    return axios({
        method: "post",
        url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=subTopicWiseSentimentBreakup`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => ({ res, params }));
};
export const fetchSubTopicWiseSentimentBreakup = (arg) => {
    const { filter, widget } = arg;
    let params = getParams(filter);
    params.aggs = "sentiments-breakup";
    const data = getParamsURLEncoded(params);

    return axios({
        method: "post",
        // url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=subTopicWiseSentimentBreakup`,
        url: `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=dataByTopic`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => ({ res, params }));
};

export const fetchTopInfluencers = (arg) => {
    const { filter, widget } = arg;
    const data = getParamsURLEncoded(getParams(filter));

    data.append("groupSize", 100);

    let url;
    if (filter.public_data === 1) url = `${getUrl("topInfluencers")}`;
    else url = `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=topInfluencers`;

    return axios({
        method: "post",
        url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    });
};

export const applyFilterDashboard = (payload) => {
    return {
        type: APPLY_FILTER_DASHBOARD,
        payload,
    };
};

export const updateDashboard = (arg) => {
    const { data, dashboard, message, skipReduxStateUpdate } = arg;
    let req = axios
        .patch(`${getUrl("dashboard_service")}/dashboards/${dashboard}?access-token=${getAccessToken()}`, data, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            if (message) toast.success(message);
            return { id: dashboard, data, skipReduxStateUpdate };
        })
        .catch((err) => {
            // console.log(err.response);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Error in updating the dashboard");
            throw err;
        });

    return {
        type: UPDATE_DASHBOARD,
        payload: req,
    };
};

export const filterRefineSortUpdateDashboard = (payload) => {
    return { type: UPDATE_FILTER_REFINE_SORT_DASHBOARD, payload };
};
export const publishedFilterRefineSortUpdateDashboard = (payload) => {
    return { type: PUBLISHED_UPDATE_FILTER_REFINE_SORT_DASHBOARD, payload };
};

export const updateDashboardTabInView = (payload) => {
    return { type: UPDATE_TAB_IN_VIEW, payload };
};

export const updateDashboardInView = (payload) => {
    return { type: UPDATE_DASHBOARD_IN_VIEW, payload };
};

export const switchConversationLayout = (payload) => {
    return { type: UPDATE_CONVERSATION_LAYOUT, payload };
};

export const switchGridLayout = (payload) => {
    return { type: UPDATE_GRID_LAYOUT, payload };
};

export function downloadAction(arg) {
    const { filter } = arg;
    let data = getParams(filter);

    data["access-token"] = getAccessToken();

    // data.push("access-token",);

    return function (dispatch) {
        return axios
            .post(`${getUrl("download")}`, data, { "Content-Type": "application/json" })
            .then((response) => {
                toast.success("Your Download request has been received and you will shortly receive an email with the Download link.");
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
                else toast.error("Some error occurred while processing your request");
            });
    };
}

export const updateChartInsightsFilters = (filters) => {
    return {
        type: UPDATE_CHART_INSIGHTS_FILTERS,
        payload: filters,
    };
};

export const addCustomQuery = (payload) => {
    return {
        type: ADD_CUSTOM_QUERY,
        payload,
    };
};

export const updateCustomQueryDashboard = (payload) => {
    return {
        type: UPDATE_CUSTOM_QUERY_DASHBOARD,
        payload,
    };
};

export const editCurrentDashboard = (payload) => {
    return {
        type: EDIT_CURRENT_DASHBOARD,
        payload,
    };
};

export const updateDashboardLayoutConfig = (payload) => {
    let { widgetListDashboardCurrent } = store.getState().dashboardReducer;
    payload.forEach((w) => {
        let id = w.i.split("_")[0];
        let temp = widgetListDashboardCurrent[id];
        // console.log(id);
        if (
            temp &&
            (temp.widget_filter.layout.x !== w.x ||
                temp.widget_filter.layout.y !== w.y ||
                temp.widget_filter.layout.w !== w.w ||
                temp.widget_filter.layout.h !== w.h)
        ) {
            // console.log("jaja", id);
            temp.widget_filter.layout.x = w.x;
            temp.widget_filter.layout.y = w.y;
            temp.widget_filter.layout.w = w.w;
            temp.widget_filter.layout.h = w.h;
            temp.config_updated = true;
            widgetListDashboardCurrent[id] = temp;
        }
    });

    return {
        type: UPDATE_DASHBOARD_LAYOUT_CONFIG,
        payload: widgetListDashboardCurrent,
    };
};

export const dashboardUpdatingStatus = (payload) => {
    return {
        type: DASHBOARD_UPDATING_STATUS,
        payload,
    };
};

export const addWidgetToDashboard = (data) => {
    console.log("firstaddWidgetToDashboard", data);
    let req = axios
        .post(`${getUrl("dashboard_service")}/widgets/addToDashboard?access-token=${getAccessToken()}`, data, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data;
        })
        .catch((error) => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("Error adding chart to the dashboard");
            return error;
        });

    return {
        type: ADD_WIDGET_TO_DASHBOARD,
        payload: req,
    };
};

export const deleteWidgetFromDashboard = (widget) => {
    let req = axios
        .delete(`${getUrl("dashboard_service")}/widgets/${widget}?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            toast.success("Chart deleted from dashboard");
            return widget;
        })
        .catch((error) => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("Error deleting chart from the dashboard");
            return error;
        });

    return {
        type: DELETE_WIDGET_FROM_DASHBOARD,
        payload: req,
    };
};

export const deleteDashboard = (id) => {
    let req = axios
        .delete(`${getUrl("dashboard_service")}/dashboards/${id}?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            toast.success("This Dashboard has been deleted and moved to Trash.");
            return widget;
        })
        .catch((error) => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            // else toast.error("Error deleting dashboard");
            return error;
        });

    return {
        type: DELETE_DASHBOARD,
        payload: req,
    };
};

export const restoreDashboard = (id) => {
    let req = axios
        .post(
            `${getUrl("dashboard_service")}/dashboards/restore?access-token=${getAccessToken()}`,
            { dashboard_id: id.toString() },
            {
                headers: {
                    "Content-type": " application/json",
                },
            },
        )
        .then((res) => {
            toast.success("Dashboard restored");
        })
        .catch((error) => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            // else toast.error("Error deleting dashboard");
            return error;
        });

    return {
        type: RESTORE_DASHBOARD,
        payload: req,
    };
};

export const saveDashboardWidgetConfig = () => {
    let { widgetListDashboardCurrent } = store.getState().dashboardReducer;

    const widgets = {};
    // console.log(widgetListDashboardCurrent);
    Object.values(widgetListDashboardCurrent).forEach((w, i) => {
        if (w.config_updated) {
            widgets[w.id] = {
                widget_filter: {
                    ...w.widget_filter,
                    layout: {
                        x: w.widget_filter.layout.x,
                        y: w.widget_filter.layout.y,
                        w: w.widget_filter.layout.w,
                        h: w.widget_filter.layout.h,
                    },
                },
            };
        }
    });

    let promises = [];

    Object.keys(widgets).forEach((w) => {
        let args = { id: w, data: widgets[w] };
        let widgetReq = dashboardWidgetUpdate(args).then((res) => res.data.data.widget);
        promises.push(widgetReq);
    });

    let req = Promise.all(promises)
        .then((res) => {
            return res;
            // toast.success("Dashboard Updated Successfully");
        })
        .catch((error) => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("Error in updating dashboard");
            return error;
        });

    return {
        type: SAVE_DASHBOARD_WIDGET_LAYOUT_CONFIG,
        payload: req,
    };
};

export const dashboardWidgetUpdate = (args) => {
    let { id, data } = args;
    return axios.patch(`${getUrl("dashboard_service")}/widgets/${id}?access-token=${getAccessToken()}`, data, {
        headers: {
            "Content-type": " application/json",
        },
    });
};

export const updateDashboardWidget = ({ id, data }) => {
    let req = dashboardWidgetUpdate({ id, data })
        .then((res) => {
            return { id, data: res.data.data.widget };
        })
        .catch((error) => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("Error in updating dashboard");
            throw Error(error);
        });

    return {
        type: UPDATE_DASHBOARD_CHART,
        payload: req,
    };
};

export const createDashboard = (name, des, companyId, userId) => {
    // console.log("did", des);

    let url = `${getUrl("dashboardCreate")}`;
    // let companyId = JSON.parse(localStorage.getItem("company")).company_id;
    // let userId = JSON.parse(localStorage.getItem("company")).user_id;
    let param = {};

    param.company_id = companyId;
    param.user_id = userId;
    param.name = name;
    if (!des === "") param.description = des;

    // console.log("did", param.description);

    let req = axios({
        method: "POST",
        url: url,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Dashboard created successfully");

            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: CREATE_DASHBOARD,
        payload: req,
    };
};

export const cloneDashboard = (val, name, des, companyId, userId) => {
    let url = `${getUrl("dashboardClone")}`;
    // let companyId = JSON.parse(localStorage.getItem("company")).company_id;

    // let userId = JSON.parse(localStorage.getItem("company")).user_id;
    let param = {};

    param.company_id = companyId;
    param.dashboard_id = val;
    param.user_id = userId;
    param.name = name;
    if (!des === "") param.description = des;

    let req = axios({
        method: "POST",
        url: url,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Dashboard successfully cloned");
            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: CLONE_DASHBOARD,
        payload: req,
    };
};

export const shareWithTeam = (id, team) => {
    let url = `${getUrl("shareURL")}`;

    let param = {};

    param.dashboard_id = id;
    param.shared_to = team.toString();
    param.share_type = "team";

    let req = axios({
        method: "POST",
        url: url,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Successfully shared with team");

            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: SHARE_WITH_TEAM,
        payload: req,
    };
};

export const shareWithCompany = (dashboardId, companyId) => {
    //console.log("hello", dashboardId, companyId);
    let url = `${getUrl("shareURL")}`;

    let param = {};

    param.dashboard_id = dashboardId;
    param.shared_to = companyId;
    param.share_type = "company";

    let req = axios({
        method: "POST",
        url: url,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Successfully shared with all members of the company");

            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: SHARE_WITH_COMPANY,
        payload: req,
    };
};

export const shareWithPublic = (dashboardId, expiryData, emailIds) => {
    let url = `${getUrl("shareURL")}`;

    let param = {};

    param.dashboard_id = dashboardId;
    param.shared_to = "public";
    param.share_type = "public";

    let req = axios({
        method: "POST",
        url: url,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Successfully generated a Public URL");

            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: SHARE_WITH_PUBLIC,
        payload: req,
    };
};

export const stopSharingWithPublic = (dashboardId) => {
    let url = `${getUrl("stopShareURL")}`;

    let param = {};

    param.dashboard_id = dashboardId;
    param.share_type = "public";

    let req = axios({
        method: "POST",
        url: url,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("Successfully disabled the link");

            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error.response;
        });

    return {
        type: STOP_SHARE_WITH_PUBLIC,
        payload: req,
    };
};

export function setSentiment({ postData: post, sentiment, company, postIndex, isComment }) {
    let data = post;
    if (!isComment) {
        let sentimentsArray = data && data._source.sentiments;
        let companyIndexInSentimentArray = sentimentsArray.findIndex((elem) => parseInt(elem.company_id) === parseInt(company.company_lite_company_id));
        if (companyIndexInSentimentArray !== -1) {
            sentimentsArray[companyIndexInSentimentArray].sentiment = sentiment.toUpperCase();
            data._source.sentiments = sentimentsArray;
        } else {
            let newSentimentObj = {
                sentiment: sentiment.toUpperCase(),
                company_id: company.company_lite_company_id,
                source: 12,
            };
            sentimentsArray.push(newSentimentObj);
            data._source.sentiments = sentimentsArray;
        }
    }

    var params = {
        _ids: isComment ? post._id : post._index + ":" + post._id,
        "sentiments.sentiment": sentiment,
    };
    params = JSON.stringify(params);
    let req = axios
        .post(`${getUrl("elastisearch_service")}/update-es-post?access-token=${getAccessToken()}`, params, {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        })
        .then((response) => {
            toast.success("Sentiment has been updated");
            return { data, postIndex, response: response.data };
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: "CONVERSATION_SENTIMENT_UPDATE",
        payload: req,
    };
}

export const updatePostAfterSentimentUpdate = (payload) => ({ type: UPDATE_POSTS_AFTER_SENTIMENT_UPDATE, payload });

export const updatePostAfterSentimentUpdateWidget = (payload) => ({ type: UPDATE_POSTS_AFTER_SENTIMENT_UPDATE_WIDGET, payload });

export const updatePostAfterTagToClient = (payload) => ({ type: UPDATE_POSTS_AFTER_TAG_CLIENT, payload });

export const updatePostAfterTagToClientWidget = (payload) => ({ type: UPDATE_POSTS_AFTER_TAG_CLIENT_WIDGET, payload });

export function fetchBlockSourceMessage(obj) {
    let req = axios
        .post(getUrl("block_source_meesage"), obj, {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${JSON.parse(localStorage.getItem("company")).lite_access_token}`,
            },
        })
        .then((res) => {
            // console.log(res.data);
            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });
    return {
        type: FETCH_BLOCK_SOURCE_MESSAGE,
        payload: req,
    };
}

export function removeIrrPost({ type, val, postId, company }) {
    let data = {
        "spam.is_spam": 2,
        _ids: postId,
    };
    //data.append('spam.is_spam', 2)
    if (["duplicate", "unwanted_ad"].indexOf(type) > -1) {
        data["spam.description"] = type;
    } else if (type === "block source") {
        data["spam.url"] = val;
        data["spam.description"] = "block_source";
        data["twenty20_username"] = JSON.parse(localStorage.getItem("company")).user_name;
    } else {
        data["spam.description"] = val;
    }
    let req = axios({
        method: "post",
        url: `${getUrl("elastisearch_service")}/update-es-post?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },
        data,
    })
        .then((res) => {
            toast.success("Successfully Marked As Irrelevant");
            return { res: res.data, type, val, postId: postId.split(":")[1] };
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: "CONVERSATION_REMOVE_IRR_POST",
        payload: req,
    };
}

export function markPostSafety(postId, newPrediction) {
    let req = axios({
        method: "post",
        url: `${getUrl("elastisearch_service")}/update-es-post?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },

        data: {
            "content_safety.prediction": newPrediction,
            _ids: postId,
        },
    })
        .then((res) => {
            toast.success("Updated Content Safety");
            return { res: res.data, postId: postId.split(":")[1] };
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occurred while processing your request");

            return error;
        });
    return {
        type: "MARK_POST_SAFETY",
        payload: req,
    };
}

export const updatePostAfterMarkAsIrr = (payload) => ({ type: UPDATE_POSTS_AFTER_MARK_IRR, payload });

export const updatePostAfterMarkAsIrrWidget = (payload) => ({ type: UPDATE_POSTS_AFTER_MARK_IRR_WIDGET, payload });

export const showBulkOptions = (payload) => ({ type: DASHBOARD_SHOW_BULK_EDIT_OPTIONS, payload });

export const toggleSelectAll = (payload) => ({ type: DASHBOARD_TOGGLE_SELECT_ALL, payload });

export const toggleSelected = (payload) => ({ type: DASHBOARD_TOGGLE_SELECTED, payload });

export const toggleToDeselect = (payload) => ({ type: DASHBOARD_TOGGLE_TO_DESELECT, payload });

export const bulkSentimentUpdate = (different_ids, sentiment, company, rawData, non_ids) => {
    return function (dispatch) {
        for (var i = 0; i < different_ids.length; i++) {
            let _id = different_ids[i].split(":")[1];
            let _index = different_ids[i].split(":")[0];
            let dataIndex = rawData.findIndex((elem) => elem._id === _id);
            let data = rawData[dataIndex];
            let sentimentsArray = data && data._source.sentiments;
            if (sentimentsArray !== undefined) {
                let companyIndexInSentimentArray = sentimentsArray.findIndex((elem) => parseInt(elem.company_id) === parseInt(company.company_lite_company_id));
                if (companyIndexInSentimentArray !== -1) {
                    sentimentsArray[companyIndexInSentimentArray].sentiment = sentiment.toUpperCase();
                    data._source.sentiments = sentimentsArray;
                    rawData[dataIndex] = data;
                } else {
                    let newSentimentObj = {
                        sentiment: sentiment.toUpperCase(),
                        company_id: company.company_lite_company_id,
                        source: 12,
                    };
                    sentimentsArray.push(newSentimentObj);
                    data._source.sentiments = sentimentsArray;
                    rawData[dataIndex] = data;
                }
                dispatch({ type: DASHBOARD_BULK_SENTIMENT_UPDATE });
            }
        }
        var params = {
            _ids: different_ids.length !== 0 ? different_ids.toString() : null,
            not_es_id: non_ids ? non_ids.toString() : null,
            "sentiments.sentiment": sentiment,
        };
        params = JSON.stringify(params);
        axios
            .post(`${getUrl("elastisearch_service")}/update-es-post?access-token=${getAccessToken()}`, params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                toast.success("Sentiment has been updated");
                dispatch({ type: DASHBOARD_BULK_SENTIMENT_UPDATE, payload: rawData });
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
                else toast.error("An error occured while processing your request");

                return error;
            });
    };
};

export const bulkContentSafetyUpdate = (different_ids, contentSafety, company, rawData, non_ids) => {
    return function (dispatch) {
        for (var i = 0; i < different_ids.length; i++) {
            let _id = different_ids[i].split(":")[1];
            let _index = different_ids[i].split(":")[0];
            let dataIndex = rawData.findIndex((elem) => elem._id === _id);
            let data = rawData[dataIndex];
            if (data._source.data_type === "image" || data._source.data_type === "video") {
                let contentSafetyArray = data._source.content_safety;
                let companyIndexInContentSafetyArray = contentSafetyArray.findIndex(
                    (elem) => parseInt(elem.company_id) === parseInt(company.company_lite_company_id),
                );
                if (companyIndexInContentSafetyArray !== -1) {
                    contentSafetyArray[companyIndexInContentSafetyArray].content_safety = contentSafety;
                    data._source.content_safety = contentSafetyArray;
                    rawData[dataIndex] = data;
                } else {
                    let newContentSafetyObj = {
                        content_safety: contentSafety,
                        company_id: company.company_lite_company_id,
                        source: 12,
                    };
                    contentSafetyArray.push(newContentSafetyObj);
                    data._source.content_safety = contentSafetyArray;
                    rawData[dataIndex] = data;
                }
                dispatch({ type: DASHBOARD_BULK_CONTENT_SAFETY_UPDATE });
            }
        }
        var params = {
            _ids: different_ids.length !== 0 ? different_ids.toString() : null,
            not_es_id: non_ids ? non_ids.toString() : null,
            "content_safety.prediction": contentSafety,
        };
        params = JSON.stringify(params);
        axios
            .post(`${getUrl("elastisearch_service")}/update-es-post?access-token=${getAccessToken()}`, params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                toast.success("Content safety has been updated");
                dispatch({ type: DASHBOARD_BULK_CONTENT_SAFETY_UPDATE, payload: rawData });
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
                else toast.error("An error occurred while processing your request");

                return error;
            });
    };
};

export const bulkMarkIrrUpdate = (ids, description, company, non_ids) => {
    let different_ids = [];
    if (ids.length !== 0) {
        ids.forEach((id) => {
            different_ids.push(id.split(":")[1]);
        });
    }

    let data = {
        "spam.is_spam": 2,
        _ids: ids.length !== 0 ? ids.toString() : null,
        not_es_id: non_ids ? non_ids.toString() : null,
    };
    data["spam.description"] = description;

    let req = axios({
        method: "post",
        url: `${getUrl("elastisearch_service")}/update-es-post?access-token=${getAccessToken()}`,
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },
        data,
    })
        .then((res) => {
            toast.success("Successfully Marked As Irrelevant");
            return { res: res.data, ids: different_ids };
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: DASHBOARD_BULK_MARK_IRR_UPDATE,
        payload: req,
    };
};

export const updateSentimentForAll = (arg) => {
    const { filter, value, deselectedPosts } = arg;
    let data = getParams(filter);
    let nonId_arr = [];
    if (deselectedPosts.length > 0) {
        deselectedPosts.forEach((x, i) => {
            nonId_arr[i] = deselectedPosts[i].split(":")[1];
        });
    }

    data.version = "v7";
    data["bulk_update[sentiments.sentiment]"] = value.toLowerCase();
    data["bulk_update[sentiments.source]"] = 12;
    data["access-token"] = getAccessToken();
    data["not_es_id"] = nonId_arr.length > 0 ? nonId_arr.toString() : null;

    data = getParamsURLEncoded(data);

    let req = axios({
        method: "post",
        url: `${getUrl("all_update")}`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => {
        toast.success("Changes will be processed and visible shortly.");
        return res.data;
    });

    return {
        type: DASHBOARD_UPDATE_SENTIMENT_FOR_ALL,
        payload: req,
    };
};

export const updateMarkIrrForAll = (arg) => {
    const { filter, value, deselectedPosts } = arg;
    let data = getParams(filter);
    let nonId_arr = [];
    if (deselectedPosts.length > 0) {
        deselectedPosts.forEach((x, i) => {
            nonId_arr[i] = deselectedPosts[i].split(":")[1];
        });
    }

    data.version = "v7";
    data["access-token"] = getAccessToken();
    data["bulk_update[spam.is_spam]"] = 2;
    data["bulk_update[spam.description]"] = value;
    data["not_es_id"] = nonId_arr.length > 0 ? nonId_arr.toString() : null;

    data = getParamsURLEncoded(data);

    let req = axios({
        method: "post",
        url: `${getUrl("all_update")}`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    }).then((res) => {
        toast.success("Changes will be processed and visible shortly.");
        return res.data;
    });

    return {
        type: DASHBOARD_UPDATE_MARK_IRR_FOR_ALL,
        payload: req,
    };
};

export function bulkDeleteFromCollection({ ids, collection_id }) {
    let data = {
        _ids: ids.join(","),
        "synced_collections.delete": collection_id,
    };

    // console.log(data);

    let req = axios
        .post(`${getUrl("elastisearch_service")}/update-es-post?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        })
        .then((res) => {
            toast.success("Deleted all selected posts from Collection");
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("Some error occurred while processing your request");
        });

    return function (dispatch) {
        dispatch({
            type: "DASHBOARD_BULK_DELETE_FROM_COLLECTION_PENDING",
        });
        req.then(() => {
            toast.success("Deleted all selected posts from Collection");
            dispatch({
                type: "DASHBOARD_BULK_DELETE_FROM_COLLECTION_FULFILLED",
                payload: ids,
            });
        }).catch((err) => {
            toast.error("Failed to delete all selected posts from Collection");
            console.log(err);
            dispatch({
                type: "DASHBOARD_BULK_DELETE_FROM_COLLECTION_REJECTED",
            });
        });
    };
}

export const updatePostAfterDeleteFromCollection = (payload) => ({ type: UPDATE_POSTS_AFTER_DELETE_FROM_COLLECTION, payload });

export function downloadComments({ parent_id, published_date }) {
    let data = new URLSearchParams();

    data.append("access-token", getAccessToken());
    data.append("offset", 1);
    data.append("recordsPerPage", 1000);
    var now = moment(new Date());
    var end = moment(new Date(published_date));
    var duration = moment.duration(now.diff(end));
    var days = duration.asDays();
    data.append("duration", Math.ceil(days) + 1);
    data.append("data", 1);
    data.append("post_type", 1);
    data.append("download_type", "csv");
    data.append("download_name", "post/comments");
    data.append("parent_id", parent_id);

    return function (dispatch) {
        return axios
            .post(`${getUrl("download")}`, data, { "Content-Type": "application/x-www-form-urlencoded" })
            .then((response) => {
                toast.success("Your Download request has been received and you will shortly receive an email with the Download link.");
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
                else toast.error("Some error occurred while processing your request");
            });
    };
}

export function fetchPostComments(id, published_date, isResearchPage, postSubType) {
    let data = new URLSearchParams();

    data.append("access-token", getAccessToken());
    data.append("parent_id", id);
    data.append("offset", 1);
    data.append("recordsPerPage", 1000);
    var now = moment(new Date());
    var end = moment(new Date(published_date));
    var duration = moment.duration(now.diff(end));
    var days = duration.asDays();
    if (postSubType === "ads") days = days + 60;
    data.append("duration", Math.ceil(days) + 1);
    data.append("data", 1);
    data.append("post_type", 1);
    if (isResearchPage) data.append("public_data", 1);

    let req = axios({
        method: "post",
        url: getUrl("post_comments"),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data,
    })
        .then((res) => res.data)
        .then(formatPostComments);

    return {
        type: "FETCH_POST_COMMENTS",
        payload: req,
    };
}

const formatPostComments = (data) => {
    return data.hits.hits.map((elem) => {
        return { ...getPostInfo(elem, JSON.parse(localStorage.getItem("company")).company_lite_company_id), _id: elem._index + ":" + elem._id };
    });
};

export function setSentimentCommentSection(sentiment, id, company, rawData) {
    return function (dispatch) {
        var params = {
            _ids: id,
            "sentiments.sentiment": sentiment,
        };
        params = JSON.stringify(params);
        axios
            .post(getUrl("sentiment_update"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${company.lite_access_token}`,
                },
            })
            .then((response) => {
                dispatch({ type: SENTIMENT_UPDATE, payload: rawData });
            })
            .catch((error) => {
                toast.error("Something went wrong while updating sentiment.");
            });
    };
}

export const setChartLoadingState = (val) => {
    return {
        type: "SET_STATIC_CHART_LOADER",
        payload: val,
    };
};

export const fetchTopImageData = () => {
    const data = {
        language: [],
        location: [],
        platform: [],
        duration: "30",
        data: 0,
        topic_data: [],
        orderBy: "post.published_date",
        order: "desc",
        offset: 1,
        recordsPerPage: 50,
        apply_exclusion: "yes",
        //aggs: "top_objects,top_scenes",
    };

    let req = axios
        .post(`${getUrl("raw_data")}`, data, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_FILTER_VALUE__FOR_IMAGE,
        payload: req,
    };
};

export const fetchImageAnaLyticsLogoList = () => {
    const req = axios
        .get(`${getUrl("image_analytics")}/logo?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_IMAGE_LOGO_LIST,
        payload: req,
    };
};
export const fetchImageAnaLyticsScenesList = () => {
    const req = axios
        .get(`${getUrl("image_analytics")}/scenes?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_IMAGE_SCENES_LIST,
        payload: req,
    };
};

export const fetchImageAnaLyticsObjectsList = () => {
    const req = axios
        .get(`${getUrl("image_analytics")}/objects?access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_IMAGE_OBJECTS_LIST,
        payload: req,
    };
};

export const applyImageFilterDashboard = (payload) => {
    return {
        type: APPLY_IMAGE_FILTER,
        payload,
    };
};

export const applyChartFilter = (val) => {
    return {
        type: "CHANGE_CHART_FILTERS",
        payload: val,
    };
};

export const configLogoList = (list) => {
    let data = {};
    data.logos = list;

    const req = axios
        .post(`${getUrl("image_analytics")}/logo/config/default?access-token=${getAccessToken()}`, data, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return res.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: CONFIG_IMAGE_LOGO_LIST,
        payload: req,
    };
};

export const supportEmailRequest = (arg) => {
    // console.log("object", arg);
    let url = `${getUrl("support_email")}`;
    let param = {};
    param.name = arg.name;
    param.message = arg.message;
    param.email = arg.email;
    param.companyName = arg.companyName;
    param.subject = arg.subject;
    // console.log("+++", param);

    let req = axios({
        method: "POST",
        url: url,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("You message has been sent successfully to the support team.");
            return res;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: SUPPORT_EMAIL,
        payload: req,
    };
};

export const toggleViewExcludedWords = (payload, deleted) => {
    return {
        type: VIEW_EXCLUDED_WORDS,
        payload: {
            payload,
            deleted,
        },
    };
};

export const maximizeWidget = (payload) => {
    return {
        type: MAXIMIZE_WIDGET,
        payload,
    };
};

export const getWidgetData3 = (arg) => {
    // console.log("lkkkkkkk", arg);
    return (dispatch) => {
        const { widget, filter, comparisionDataType } = arg;

        // if (arg.logos && arg.image_analytics_types) {
        if (arg.image_analytics_types) filter.image_analytics_types = arg.image_analytics_types;
        if (arg.logos) filter.logos = arg.logos;
        if (arg.product_attribute_categories) {
            if (arg.product_attribute_categories[0] === "selectAll")
                filter.product_attribute_categories = Object.keys(ProductAttributes.data).map((val) => ProductAttributes.data[val].categoryName);
            else filter.product_attribute_categories = arg.product_attribute_categories;
        }
        // }

        const data = getParams(filter);

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id, comparisionData: comparisionDataType });
        let url;
        if (filter.public_data === 1) url = `${getUrl("searchaggs")}`;
        else url = `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}&apiWrapperIdentifiers=dataByTopic`;

        axios
            .post(url, data, {
                headers: {
                    "Content-type": "application/json",
                },
            })
            .then((res) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    comparisionData: comparisionDataType,
                    payload: formatData({
                        data: filter.public_data === 1 ? res.data : res.data.data,
                        chart_name: widget.chart_name,
                        params: data,
                        comparisionData: comparisionDataType,
                    }),
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
};

export function fetchCompetitorInsightsData(arg) {
    const { widget, filter, accountList } = arg;
    const data = getParams(filter);

    return function (dispatch) {
        if (widget.chart_name === "compRecentPosts") {
            dispatch(fetchCompetitorPostsData(arg, data));
            return;
        }
        if (widget.chart_name === "compByHashtags") {
            dispatch(fetchCompetitorByHashtags(arg, data));
            return;
        }
        if (widget.chart_name === "compByEngagement") {
            dispatch(fetchCompetitorByEngagement(arg, data));
            return;
        }

        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });

        let tableList;
        const engagementPromiseArray = accountList.map((account) =>
            fetchCompetitorEngagementData(data, account?.userName, account?.platform, account?.research_query_id),
        );
        let engagementDataPromise = Promise.all(engagementPromiseArray);

        engagementDataPromise
            .then((engagementData) => {
                let pages = engagementData.map((account) => {
                    return { username: account?.handler, platform: account?.platform };
                });
                pages = pages.filter(Boolean);
                const params = {};

                params["users"] = pages;
                params["start_date"] = data.start_date;
                params["end_date"] = data.end_date;

                fetchCompetitorFollower(params).then((followerData) => {
                    tableList = engagementData.map((el) => {
                        const nameObj = accountList?.find((ac) => ac?.research_query_id === el?.research_query_id);
                        const followersObj = followerData?.find((ac) => ac?.page === el?.handler);

                        const userName = nameObj?.userName;
                        const name = nameObj?.name;
                        const entity = nameObj?.entity;
                        const country = nameObj?.country;
                        const followersCount = followersObj?.followers;
                        const followersGrowth = followersObj?.followersGrowth;
                        const platform = nameObj?.platform;
                        const subtopic_id = nameObj?.subtopic_id;
                        const modified_date = nameObj?.modified_date;

                        return { ...el, userName, name, followersCount, followersGrowth, entity, country, platform, subtopic_id, modified_date };
                    });

                    tableList = tableList.filter(Boolean);
                    tableList = tableList.filter((ac) => ac.userName !== undefined);

                    dispatch({
                        type: "FETCH_CHART_DATA_FULFILLED",
                        widgetId: widget.id,
                        payload: tableList,
                    });
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
}

const capitalizeFirstLetter = (str, locale = navigator.language) => {
    return str?.replace(/^\p{CWU}/u, (char) => char.toLocaleUpperCase(locale));
};

export function fetchCompetitorPostsData(arg, data) {
    const { widget, selectedCompetitorAccount, order, orderBy } = arg;

    return function (dispatch) {
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });
        fetchCompetitorPosts(
            data,
            selectedCompetitorAccount?.userName,
            selectedCompetitorAccount?.research_query_id,
            selectedCompetitorAccount?.name,
            selectedCompetitorAccount?.userName,
            selectedCompetitorAccount?.platform,
            order,
            orderBy,
        )
            .then((postsData) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: postsData,
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                return err;
            });
    };
}

const fetchCompetitorByHashtags = (arg, data) => {
    const { selectedCompetitorAccount, widget } = arg;

    let params = new URLSearchParams();

    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("custom_query", `handlers.value:"${selectedCompetitorAccount.userName}"`);
    params.append("post_type", "0");
    params.append("aggs", "by_hashtags");
    if (selectedCompetitorAccount?.platform === "facebook") params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    if (selectedCompetitorAccount?.platform === "twitter") params.append("platform", ["6ce32a97-a789-11e4-a34f-74867a1157ba"]);
    if (selectedCompetitorAccount?.platform === "instagram") params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);

    return (dispatch) => {
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: response.data?.aggregations?.by_hashtags?.buckets || [],
                });
                return response.data?.aggregations?.by_hashtags?.buckets || [];
            })
            .catch((error) => {
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                console.log(error);
            });
    };
};

const fetchCompetitorByEngagement = (arg, data) => {
    const { selectedCompetitorAccount, widget } = arg;
    // console.log(arg);
    let params = new URLSearchParams();

    // const aggs_val = arg.aggs_val;

    let interval = arg.aggs_val;
    if (interval === "daily") interval = "day";
    else if (interval?.slice(-2) === "ly") interval = interval?.slice(0, interval.length - 2);
    // if (aggs_val) {
    //     if (aggs_val === "yearly") interval = "year";
    //     else if (aggs_val === "monthly") interval = "month";
    //     else if (aggs_val === "weekly") interval = "week";
    //     else interval = "day";
    // }

    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("custom_query", `handlers.value:"${selectedCompetitorAccount.userName}"`);
    params.append("post_type", "0");
    params.append("aggs", "likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown,view_datewise_breakdown");
    params.append("aggs-interval", interval);
    // params.append("aggs-interval", aggs_val);
    if (selectedCompetitorAccount?.platform === "facebook") params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    if (selectedCompetitorAccount?.platform === "twitter") params.append("platform", ["6ce32a97-a789-11e4-a34f-74867a1157ba"]);
    if (selectedCompetitorAccount?.platform === "instagram") params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);

    return (dispatch) => {
        dispatch({ type: "FETCH_CHART_DATA_PENDING", widgetId: widget.id });

        axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let obj = {
                    nodata: response.data.hits.total === 0,
                    likes_agg: [],
                    likes_avg: 0,
                    comments_agg: [],
                    comments_avg: 0,
                    shares_agg: [],
                    shares_avg: 0,
                    views_agg: [],
                    views_avg: 0,
                    total_agg: [],
                    total_avg: 0,
                };

                let totallength = response.data.hits.total || 1;

                let total = 0;
                let totalInd = 0;
                let total_agg = {};
                let tz = JSON.parse(localStorage.company).user_timezone_name;

                response.data.aggregations.likes_datewise_breakdown.buckets.forEach((likes) => {
                    let d = +moment(likes.key).tz(tz).format("x");
                    obj.likes_agg.push([d, likes.data_stats.sum || 0]);
                    total_agg[d] = likes.data_stats.sum;
                    totalInd += likes.data_stats.sum;
                });
                obj.likes_avg = +(totalInd / totallength).toFixed(2);
                total += totalInd;

                totalInd = 0;
                response.data.aggregations.comments_datewise_breakdown.buckets.forEach((comments) => {
                    let d = +moment(comments.key).tz(tz).format("x");
                    obj.comments_agg.push([d, comments.data_stats.sum || 0]);
                    totalInd += comments.data_stats.sum;
                    total_agg[d] += comments.data_stats.sum;
                });
                obj.comments_avg = +(totalInd / totallength).toFixed(2);
                total += totalInd;

                totalInd = 0;
                response.data.aggregations.shares_datewise_breakdown.buckets.forEach((shares) => {
                    let d = +moment(shares.key).tz(tz).format("x");
                    obj.shares_agg.push([d, shares.data_stats.sum || 0]);
                    totalInd += shares.data_stats.sum;
                    total_agg[d] += shares.data_stats.sum;
                });
                obj.shares_avg = +(totalInd / totallength).toFixed(2);
                total += totalInd;

                totalInd = 0;
                response.data.aggregations.view_datewise_breakdown.buckets.forEach((views) => {
                    let d = +moment(views.key).tz(tz).format("x");
                    obj.views_agg.push([d, views.data_stats.sum || 0]);
                    totalInd += views.data_stats.sum;
                    total_agg[d] += views.data_stats.sum;
                });
                obj.views_avg = +(totalInd / totallength).toFixed(2);
                total += totalInd;

                obj.total_agg = Object.entries(total_agg).map(([k, v]) => [+k, v || 0]);
                obj.total_avg = +(total / totallength).toFixed(2);

                dispatch({
                    type: "FETCH_CHART_DATA_FULFILLED",
                    widgetId: widget.id,
                    payload: obj || [],
                });
                return obj || [];
            })
            .catch((error) => {
                dispatch({ type: "FETCH_CHART_DATA_REJECTED", widgetId: widget.id, payload: err });
                console.log(error);
            });
    };
};

const fetchCompetitorEngagementData = (filter, handler, platform, query_id) => {
    let params = new URLSearchParams();

    params.append("start_date", filter.start_date);
    params.append("end_date", filter.end_date);
    params.append("data", "0");
    params.append("orderBy", "impact_value");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "0");
    // params.append("custom_query", `post.page_id:${selectedPage}`);
    params.append("custom_query", `handlers.value:"${handler}"`);
    params.append("aggs", "total_impact_value,view_datewise_breakdown,impressions_datewise_breakdown");
    if (platform === "facebook") params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    else params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);

    const getTotalVal = (arr) => {
        if (!arr) return;
        return arr.buckets.reduce((agg, a) => agg + a.data_stats.sum, 0);
    };

    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            const data = {
                engagement: response.data?.aggregations?.total_impact_value?.value,
                impressions: getTotalVal(response.data?.aggregations?.impressions_datewise_breakdown),
                reach: getTotalVal(response.data?.aggregations?.view_datewise_breakdown),
                posts: response.data?.hits?.total,
                handler: handler,
                research_query_id: query_id,
                platform,
            };
            return data;
        })
        .catch((error) => {
            console.log(error);
        });

    return res;
};

const fetchCompetitorFollower = (params) => {
    let res = axios
        .post(getUrl("competitor_follower"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            const followersCountData = response.data?.data?.total_followers?.map((ac) => {
                const page = ac.username;
                const followers = ac.count;
                const platform = ac.platform;
                return { page: page, followers: followers, platform };
            });

            const followersGrowthData = response.data?.data?.followers_growth?.map((ac) => {
                const page = ac.username;
                const growth = ac.count;
                const platform = ac.platform;
                return { page: page, growth: growth, platform };
            });
            let mergedData = followersCountData?.map((ac) => {
                const commonAc = followersGrowthData?.find((el) => ac.page === el.page && ac.platform === el.platform);
                if (commonAc) {
                    return { page: commonAc.page, followers: ac.followers, followersGrowth: commonAc.growth, platform: commonAc.platform };
                }
            });
            mergedData = mergedData?.filter(Boolean);
            return mergedData;
        })
        .catch((error) => {
            console.log(error);
        });

    return res;
};

export const fetchCompetitorPosts = (filter, handler, query_id, name, userName, platform, postOrder, postOrderBy) => {
    let params = new URLSearchParams();

    let order = postOrder,
        orderBy = postOrderBy;

    params.append("start_date", filter.start_date);
    params.append("end_date", filter.end_date);
    params.append("data", "1");
    params.append("orderBy", orderBy);
    params.append("order", order);
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("post_type", "0,3,4");
    // params.append("custom_query", `post.page_id:${selectedPage}`);
    params.append("custom_query", `handlers.value:"${handler}"`);
    if (platform === "facebook") params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    if (platform === "twitter") params.append("platform", ["6ce32a97-a789-11e4-a34f-74867a1157ba"]);
    if (platform === "instagram") params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);

    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            const dt = response.data?.hits?.hits?.filter((item) => item?._source?.post?.post_subtype !== "ads");
            let tz = JSON.parse(localStorage.company).user_timezone_name;
            let recentPosts = [];
            dt?.forEach((item) => {
                if (item) {
                    let image_url =
                        "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post?.media[0].folder + "/" + item?._source?.post?.media[0].name;
                    let profile_pic =
                        "https://2020assets.s3.amazonaws.com/images/" +
                        item?._source?.post_author?.media[0].folder +
                        "/" +
                        item?._source?.post_author?.media[0].name;
                    let totalEngagement =
                        item?._source.post?.engagement_values?.like_count +
                        item?._source.post?.engagement_values?.comment_count +
                        item?._source.post?.engagement_values?.share_count +
                        item?._source.post?.engagement_values?.view_count;
                    recentPosts.push({
                        gender: item?._source?.post_author?.gender,
                        profile_pic: profile_pic,
                        username: item?._source?.handlers[0].value,
                        post_type: item?._source?.post?.media[0].type,
                        image_url: image_url,
                        content: item?._source?.post?.content,
                        title: item?._source?.post?.title,
                        post_url: item?._source?.post?.url,
                        created_date: moment(item?._source?.post?.published_date).tz(tz).format("DD MMM YYYY"),
                        hover_date: moment(item?._source?.post?.published_date).tz(tz).format("LLLL z"),
                        engagement: item?._source?.post?.engagement_values,
                        totalEngagement: totalEngagement,
                        platform: item?._source?.platforms[0].short_name,
                    });
                }
            });

            recentPosts = recentPosts.filter((item) => !item?.post_url?.includes("stories"));
            recentPosts = recentPosts.slice(0, 10);
            return { research_query_id: query_id, posts: recentPosts, name: name, userName: userName, platform: platform };
        })
        .catch((error) => {
            console.log(error);
        });

    return res;
};

export const advanceEditor = (bool) => {
    return {
        type: "ADVANCE_EDITOR",
        payload: bool,
    };
};

export const getAdvanceWidgetData = async (arg, originalArg) => {
    // return (dispatch) => {;
    let result;
    const { widget, filter, comparisionDataType } = arg;

    // if (arg.logos && arg.image_analytics_types) {
    if (arg.image_analytics_types) filter.image_analytics_types = arg.image_analytics_types;
    if (arg.logos) filter.logos = arg.logos;
    if (arg.product_attribute_categories) {
        if (arg.product_attribute_categories[0] === "selectAll")
            filter.product_attribute_categories = Object.keys(ProductAttributes.data).map((val) => ProductAttributes.data[val].categoryName);
        else filter.product_attribute_categories = arg.product_attribute_categories;
    }

    if (arg.advanceChart) {
        filter.advanceChart = arg.advanceChart;
    }
    // }
    console.log("firstarrrgs", arg, originalArg);
    const data = getParams(filter);

    if (data.platform) data.platform = data.platform.filter((ele) => ele !== "6ce32d7c-a789-11e4-a34f-74867a1157ba");
    data["exclude_platform_ids"] = ["6ce32d7c-a789-11e4-a34f-74867a1157ba"];
    if (originalArg.advanceChart.dimension_name.value == "Top Positive Keyword") {
        data["sentiment"] = "positive";
    } else if (originalArg.advanceChart.dimension_name.value == "Top Negative Keyword") {
        data["sentiment"] = "negative";
    }

    if (originalArg.advanceChart.breakdown_dimension_name.value == "Top Positive Keyword") {
        data["sentiment"] = "positive";
    } else if (originalArg.advanceChart.breakdown_dimension_name.value == "Top Negative Keyword") {
        data["sentiment"] = "negative";
    }

    // if (originalArg?.filter?.extras[0]?.key == "Aggs_Interval" && originalArg.advanceChart.dimension_name.label === "published_date") {
    //     data["aggs-interval"] = "day";
    // } else if (originalArg?.filter?.extras[0]?.key == "Aggs_Interval" && originalArg.advanceChart.breakdown_dimension_name.label === "published_date") {
    //     data["aggs-interval"] = "day";
    // }

    if (originalArg.advanceChart.breakdown_dimension_name) {
        data["size"] = 10;

        // if (originalArg?.filter?.extras[0]?.key == "size" && originalArg.advanceChart.dimension_name.label === "product_attributes") {
        //     data["size"] = 1;
        // }
    } else {
        data["size"] = 20;
        // if (originalArg?.filter?.extras[0]?.key == "size" && originalArg.advanceChart.dimension_name.label === "product_attributes") {
        //     data["size"] = 1;
        // }
    }
    if (["entity_types"].includes(arg.advanceChart.breakdown_dimension_name)) {
        if (originalArg.filter.entityType == "person") {
            data["entity_boolean"] = "(post.entity_sub_type:male OR post.entity_sub_type:female)";
        } else if (originalArg.filter.entityType == "non-person") {
            data["entity_boolean"] = "( post.entity_sub_type:brand OR post.entity_sub_type:news)";
        } else {
            data["entity_boolean"] = "(post.entity_sub_type:male OR post.entity_sub_type:female OR post.entity_sub_type:brand OR post.entity_sub_type:news)";
        }
    }
    if (["entity_types"].includes(arg.advanceChart.dimension_name)) {
        if (originalArg.filter.entityType == "person") {
            data["entity_boolean"] = "(post.entity_sub_type:male OR post.entity_sub_type:female)";
        } else if (originalArg.filter.entityType == "non-person") {
            data["entity_boolean"] = "( post.entity_sub_type:brand OR post.entity_sub_type:news)";
        } else {
            data["entity_boolean"] = "(post.entity_sub_type:male OR post.entity_sub_type:female OR post.entity_sub_type:brand OR post.entity_sub_type:news)";
        }
    }
    console.log("dattttta", data, originalArg);

    // dispatch({ type: "FETCH_ADVANCE_CHART_DATA_PENDING" });
    let url;
    let isTopicsSubTopicsDimensionPresent;
    if (!arg.query) url = `${getUrl("searchaggs")}`;
    else url = `${getUrl("dashboard_service")}/widgets/${arg.widget.id}/query?access-token=${getAccessToken()}`;

    if (arg.advanceChart.dimension_name === "topics_data") {
        url = `${url}&apiWrapperIdentifiers=dataByTopic`;
    } else if (arg.advanceChart.dimension_name === "sub_topics_data") {
        url = `${url}&apiWrapperIdentifiers=dataBySubTopic`;
    }

    if (["topics_data", "sub_topics_data"].includes(arg.advanceChart.dimension_name)) {
        isTopicsSubTopicsDimensionPresent = arg.advanceChart.dimension_name;
        if (!arg.advanceChart.breakdown_dimension_name) {
            arg.advanceChart.dimension_name = "";
        }
        if (arg.advanceChart.breakdown_dimension_name) {
            arg.advanceChart.dimension_name = arg.advanceChart.breakdown_dimension_name;
            arg.advanceChart.breakdown_dimension_name = "";
        }
    }
    // url = `${getUrl("searchaggs")}`;
    // else url = `${getUrl("dashboard_service")}/widgets/${widget.id}/query?access-token=${getAccessToken()}`;
    if (arg.advanceChart.dimension_name === "moments" || arg.advanceChart.breakdown_dimension_name === "moments") {
        data["child_tags_of"] = 10900;
    }

    await axios
        .post(url, data, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((res) => {
            result = formatData({
                data: res.data,

                params: data,
                advanceChart: { ...arg.advanceChart, isTopicsSubTopicsDimensionPresent, widgetId: arg.widget?.id || null },
                comparisionData: comparisionDataType,
            });

            return JSON.parse(JSON.stringify(result));
        })
        .catch((err) => {
            console.log(err);

            return err;
        });

    return {
        type: "FETCH_ADVANCE_CHART_DATA",
        widgetId: widget?.id,
        comparisionData: comparisionDataType,
        payload: result,
    };
    // };
};

export const updateViewCount = (widgetId, isChecked) => {
    // console.log("lllll", widgetId, isChecked);
    return {
        type: EXCLUDE_VIEW_COUNT_CHECKBOX,
        payload: {
            widgetId,
            isChecked,
        },
    };
};

export const getAdvanceWidgetDataWrapper = (arg) => {
    console.log("firstargggs", arg);
    let originalArg = JSON.parse(JSON.stringify(arg));
    return async (dispatch) => {
        try {
            const masterFilterData = store.getState().filterSettingReducer;
            const topicsObject = store.getState().filterSettingReducer.topicsObject;
            const excludeViewboxObj = store.getState().dashboardReducer.viewCountCheckboxes;

            let requests = [];

            arg.advanceChart = {
                metric_name: arg.advanceChart.metric_name.label || arg.advanceChart.metric_name,
                dimension_name: arg.advanceChart.dimension_name.label || arg.advanceChart.dimension_name,
                breakdown_dimension_name: arg.advanceChart.breakdown_dimension_name.label || arg.advanceChart.breakdown_dimension_name,
                breakdown_metric_name: arg.advanceChart.breakdown_metric_name.label || arg.advanceChart.breakdown_metric_name,
            };

            // 2D - 2M && 1D - 2M
            if (arg.advanceChart.breakdown_metric_name) {
                let arg1 = JSON.parse(JSON.stringify(arg, originalArg));
                let arg2 = JSON.parse(JSON.stringify(arg, originalArg));

                arg2 = {
                    ...arg2,
                    advanceChart: {
                        metric_name: arg.advanceChart.breakdown_metric_name,
                        dimension_name: arg.advanceChart.dimension_name,
                        breakdown_dimension_name: arg.advanceChart.breakdown_dimension_name,
                        breakdown_metric_name: arg.advanceChart.breakdown_metric_name,
                    },
                };

                requests.push(getAdvanceWidgetData(arg1, originalArg));
                requests.push(getAdvanceWidgetData(arg2, originalArg));
                requests.push(masterFilterData);
                requests.push(topicsObject);
                requests.push(excludeViewboxObj);
            } else {
                // 1D - 1M && 2D - 1M
                requests.push(getAdvanceWidgetData(arg, originalArg));
            }

            dispatch({
                type: "FETCH_ADVANCE_CHART_DATA_WRAPPER_PENDING",
                payload: arg,
            });
            let results = await Promise.all(requests);

            dispatch({
                type: "FETCH_ADVANCE_CHART_DATA_WRAPPER_FULFILLED",
                payload: results,
            });
        } catch (error) {
            return {
                type: "FETCH_ADVANCE_CHART_DATA_REJECTED",
                payload: { error, arg },
            };
        }
    };
};
export const reloadTopTopics = (payload) => {
    return {
        type: "RELOAD_TOP_TOPICS_BY_DATA_USAGE",
        payload,
    };
};
export const resetReloadCount = () => {
    return {
        type: "RESET_RELOAD_COUNT",
    };
};
